import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Action, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs';
import { KeycloakGnService } from '../shared/services/keycloak-gn.service';
import { SnackbarService } from '../shared/services/snackbar.service';
import { AppActions } from './app.actions';
import { APP_STATE_TOKEN, AppStateModel, INITIAL_APP_STATE } from './app.state.models';
import { ConfigsService } from './services/configs.service';

@State<AppStateModel>({
  name: APP_STATE_TOKEN,
  defaults: INITIAL_APP_STATE,
})
@Injectable()
export class AppState {
  snackbarService = inject(SnackbarService);
  constructor(
    private configService: ConfigsService,
    private keycloakGnService: KeycloakGnService,
    private router: Router,
  ) {}

  @Action(AppActions.seMaxtWidthScreen)
  setWidthScreen(
    ctx: StateContext<AppStateModel>,
    action: InstanceType<typeof AppActions.seMaxtWidthScreen>,
  ) {
    ctx.patchState({ widthScreen: action.maxWidthScreen });
  }

  @Action(AppActions.showLoader)
  showLoader(ctx: StateContext<AppStateModel>) {
    ctx.patchState({ showLoader: ctx.getState().showLoader + 1 });
  }
  @Action(AppActions.initLoader)
  initLoader(ctx: StateContext<AppStateModel>) {
    ctx.patchState({ showLoader: 0 });
  }

  @Action(AppActions.hideLoader)
  hideLoader(ctx: StateContext<AppStateModel>) {
    const state = ctx.getState();
    const value = state.showLoader - 1 < 0 ? 0 : state.showLoader - 1;
    ctx.patchState({ showLoader: value });
  }
  @Action(AppActions.setScreenSize)
  setScreenSize(
    ctx: StateContext<AppStateModel>,
    action: InstanceType<typeof AppActions.setScreenSize>,
  ) {
    ctx.patchState({ screenWidthSize: action.size });
  }

  @Action(AppActions.getMessagesExtensionsFrontReader)
  getMessagesExtensionsFrontReader(
    ctx: StateContext<AppStateModel>,
    action: InstanceType<typeof AppActions.getMessagesExtensionsFrontReader>,
  ) {
    ctx.dispatch(new AppActions.showLoader());
    return this.configService.getMessagesExtensionsFR().pipe(
      tap((data) => {
        ctx.dispatch(new AppActions.hideLoader());
        ctx.patchState({ messagesExtensionsFrontReader: data });
      }),
      catchError((error) => {
        ctx.dispatch(new AppActions.hideLoader());
        ctx.dispatch(new AppActions.toastError(error));
        return error;
      }),
    );
  }

  @Action(AppActions.logout)
  logout(ctx: StateContext<AppStateModel>) {
    this.keycloakGnService.logout().then(() => {
      this.router.navigate(['/']);
    });
  }

  @Action(AppActions.toastError)
  toastError(ctx: StateContext<AppStateModel>, action: InstanceType<typeof AppActions.toastError>) {
    const errorData = (action.error as any).error;
    if (!!errorData) {
      this.snackbarService.red(errorData.message);
      return;
    }
    this.snackbarService.red(action.error.message || 'Une erreur est survenue');
  }
}
